import React, { useState } from 'react';
import { Image } from '@/shared/ui/image';
import { Box } from '@/shared/ui/box';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import {
  BodyTextMediumC,
  BodyTextMediumB,
  BodyTextRegularD,
  HeadingBoldH5,
} from '@/shared/ui/typography2';
import Switch from '@/shared/ui/switch/switch';
import {
  CardContent,
  InfoBlock,
  TopInfo,
  BottomInfo,
  SwitchBlock,
  TextBlock,
} from './styles';

const CardBonuse = ({ mobileLandscape }) => {
  const [statusSwitch, setStatusSwitch] = useState(false);

  return (
    <CardContent $active={statusSwitch}>
      <InfoBlock>
        <Image
          width={mobileLandscape ? 56 : 79}
          height={mobileLandscape ? 75 : 105}
          src="/images/dev/kings-crown.png"
          alt=""
        />
        <TextBlock>
          <TopInfo>
            {mobileLandscape ? (
              <>
                <BodyTextMediumB>400 FS</BodyTextMediumB>
                <BodyTextMediumC>King's Crown</BodyTextMediumC>
              </>
            ) : (
              <>
                <HeadingBoldH5>400 FS</HeadingBoldH5>
                <BodyTextMediumC>King's Crown</BodyTextMediumC>
              </>
            )}
          </TopInfo>
          <BottomInfo>
            <BodyTextRegularD>bet per spin is 0.10 RON</BodyTextRegularD>
          </BottomInfo>
        </TextBlock>
      </InfoBlock>
      <SwitchBlock>
        <Switch
          onCheckedChange={() => setStatusSwitch((val) => !val)}
          checked={statusSwitch}
        />
      </SwitchBlock>
    </CardContent>
  );
};

const CardBonuseWithBreakpointSlice = withBreakpointsSlice(
  CardBonuse,
  ({ mobileLandscape }) => ({ mobileLandscape })
);

export { CardBonuseWithBreakpointSlice as CardBonuse };
